import "./InfoBoard.css"
import InfoSingle from "../InfoSingle/InfoSingle";
// TODO: test if varying lengths affect the layout.
export default function InfoBoard(props) {

    function chooseDisplayStyling({ boardType = "default", cardCount = 3, imgWrapperRow = 1,
                                    textWrapperRow = 2, showTextDetails = true, showTitle = true,
                                    ...prop}) {
        if (boardType === 'banner') {
            return {
                boardType: boardType,
                cardCount: 1,
                imgWrapperRow: 1,
                textWrapperRow: 1,
                showTextDetails: showTextDetails,
                showTitle: showTitle,
                ...prop
            };
        }
        else {
            return {
                boardType: boardType,
                cardCount: cardCount,
                imgWrapperRow: imgWrapperRow,
                textWrapperRow: textWrapperRow,
                showTextDetails: showTextDetails,
                showTitle: showTitle,
                ...prop
            };
        }
    }

    const styling = chooseDisplayStyling(props);
    const contentToDisplay = [];
    if (props.boardCategory === "featureBanner") {
        props.contentDataArray.forEach(item => {
            if (item.is_feature) { contentToDisplay.push(item); }
        })
    }
    else if (props.boardCategory === "all"){
        props.contentDataArray.forEach(item => {
            contentToDisplay.push(item)
        })
    }
    else {
        props.contentDataArray.forEach(item => {
            if (item.category === props.boardCategory) {
                contentToDisplay.push(item);
            }
        });
    }

    // TODO: sample_event_array should be replaced with props.contentDataArray when possible.
    return (
        <>
            { styling.showTitle ? ( <h1>{props.title}</h1> ) : null }
            <div className="infoboard" style={{ gridTemplateColumns: `repeat(${styling.cardCount}, 1fr)` }}>
                {contentToDisplay.length > 0 ?
                    contentToDisplay.slice(0, styling.cardCount).map((singleData, index) => <InfoSingle styling={styling} page_addressOnly={false} key={index} {...singleData} />):
                    <p>No data to show!</p>}
            </div>
        </>
    );
}